import { combineReducers } from "@reduxjs/toolkit";
import actionSlice from "./slices/actionSlice";
import appSlice from "./slices/appSlice";
import authSlice from "./slices/authSlice";
import categoriesSlice from "./slices/categoriesSlice";
import userSlice from "./slices/userSlice";
import actionListSlice from "./slices/actionListSlice";
import categoriesListSlice from "./slices/categoriesListSlice";
import assetSlice from "./slices/assetSlice";
import scenarioSlice from "./slices/scenarioSlice";
import incidentListSlice from "./slices/incidentsListSlice";
import incidentSlice from "./slices/incidentSlice";
import contactSlice from "./slices/contactSlice";
import repairerSlice from "./slices/repairerSlice";
import incidentNoteSlice from "./slices/incidentNoteSlice";
import incidentHistorySlice from "./slices/incidentHistorySlice";
import featureFlagsSlice from "./slices/featureFlagsSlice";
import incidentActionSlice from "./slices/incidentActionSlice";
import jobsheetSlice from "./slices/jobsheetSlice";

const rootReducer = combineReducers({
  app: appSlice,
  user: userSlice,
  action: actionSlice,
  actionList: actionListSlice,
  categories: categoriesSlice,
  categoriesList: categoriesListSlice,
  auth: authSlice,
  assets: assetSlice,
  repairers: repairerSlice,
  scenario: scenarioSlice,
  incidentList: incidentListSlice,
  incident: incidentSlice,
  incidentNote: incidentNoteSlice,
  contact: contactSlice,
  incidentHistory: incidentHistorySlice,
  featureFlags: featureFlagsSlice,
  incidentAction: incidentActionSlice,
  jobsheets: jobsheetSlice,
});

export default rootReducer;
